export const emailListStyles = (theme) => {
  return {
    gridOccupy: {
      width: "100%",
    },
    container: {
      marginTop: "3px",
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      [theme.breakpoints.down("sm")]: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      },
      [theme.breakpoints.up("sm")]: {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        flexDirection: "row",
      },
    },
    root1: {
      display: "flex",
      flexDirection: "row",
      flex: 1,
      width: "100%",
      // maxWidth: '',
      alignItems: "baseline",
      justifyContent: "flex-start",
      backgroundColor: "#fff",
      minHeight: "400px",
      height: "auto",
      margin: "4px",
    },
    root2: {
      display: "flex",
      flexDirection: "row",
      flex: 1,
      width: "100%",
      alignItems: "baseline",
      justifyContent: "left",
      backgroundColor: "#fff",
      overflow: "scroll",
      padding: "15px",
      height: "350px",
      margin: "4px",
      marginBottom: "10px",
      [theme.breakpoints.down("sm")]: {
        height: "250px",
      },
      [theme.breakpoints.up("sm")]: {
        height: "350px",
      },
    },
    form: {
      display: "flex",
      flex: 1,
      justifyContent: "center",
      flexWrap: "wrap",
      paddingTop: "28px",
      paddingLeft: theme.spacing(2.5),
      paddingRight: theme.spacing(2.5),

    },
   
    inputStyles: {
      height: 25,
      minWidth: 140,
      marginRight: theme.spacing(1),
      marginLeft: theme.spacing(1),
      marginTop: theme.spacing(2.5),
      marginBottom: theme.spacing(3),
      flex: 1,
      paddingLeft: 5,
      '& .MuiFormHelperText-contained': {
        marginLeft: 0,
        fontSize: 10,
      },
      '& .MuiFormHelperText-root': {
        marginLeft: 0,
        fontSize: 10,
      },
      '& .MuiInputLabel-outlined': {
        // fontSize: 10,
        paddingLeft: 5,
        paddingRight: 0,
      },
      // '& .MuiOutlinedInput-notchedOutline': {
      //   borderColor: '#000000',
      // },
      '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#000000',
      },
    },
    button: {
      marginRight: theme.spacing(0.5),
      marginLeft: theme.spacing(0.5),
      color: "#fff", //D1373F
      backgroundColor: "#556cd6",
      border: "none",
      // borderColor: "#556cd6",
      minWidth: theme.spacing(12),
      borderWidth: theme.spacing(0.2),
      "&:hover": {
        backgroundColor: "#556cd6",
        // borderColor: "#556cd6",
      },
    },

    icon: {
      fill: "#fff",
    },
    btnDiv: {
      marginTop: "15px",
      marginBottom: "2rem",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
    },
    mailList: {
      marginLeft: "18px",
      color: "#6a6ae1",
      textDecoration: "underline",
      [theme.breakpoints.down("sm")]: {
        height: "250px",
      },
      [theme.breakpoints.up("sm")]: {
        height: "auto",
      },
    },

    uploadLabel: {
    
    },
    textArea: {
      // padding: " 6px 12px",
      // cursor: "pointer",
      // width: '80%'
    },
    label: {
      color: "#6e6e6e",
      fontWeight: "400",
      marginBottom: "3px",
    },
    inputEmail: {
      height: "35px",
      width: "80%",
      border: "2px solid #ccc",
      outline: "none",
      borderRadius: "5px",
      padding: "2px",

    },
    inputMailDump: {
      display: "inline-block",
      width: "80%",
      maxWidth: "600px",
      maxHeight: '245px',
      border: "2px solid #ccc",
      outline: "none",
      borderRadius: "5px",
      padding: "2px",
      [theme.breakpoints.down("sm")]: {
        maxWidth: "250px",
      },
      [theme.breakpoints.up("sm")]: {
        maxWidth: "600px",
      },
    },
    inputUpload: {
      border: "2px solid #ccc",
      display: "inline-block",
      borderRadius: "5px",
      padding: " 6px 15px",
      cursor: "pointer",
    },
  };
};
